(() => {
  const selector = '[data-ascend-shipping-progress]';
  const priorStates = new Map();
  let requestId = 0;
  const money = (cents) => new Intl.NumberFormat('en-AU', {
    style: 'currency', currency: 'AUD'
  }).format(cents / 100);

  function visibleForAnnouncement(element) {
    if (element.dataset.placement === 'notification') {
      return Boolean(element.closest('.cart-notification.active'));
    }
    return !element.hidden;
  }

  function merchandiseTotal(cart) {
    // Some checkout-linked cart updates include delivery in total_price.
    // Use merchandise after line discounts, then subtract only order discounts.
    if (!Number.isFinite(cart?.items_subtotal_price) ||
        !Array.isArray(cart.cart_level_discount_applications)) return null;
    let current = cart.items_subtotal_price;
    for (const discount of cart.cart_level_discount_applications) {
      if (discount.target_type !== 'line_item') continue;
      if (!Number.isFinite(discount.total_allocated_amount)) return null;
      current -= discount.total_allocated_amount;
    }
    return Math.max(0, current);
  }

  function render(cart) {
    const current = merchandiseTotal(cart);
    if (current === null || !Number.isFinite(cart?.item_count)) return;
    const elements = document.querySelectorAll(selector);
    const visible = [...elements].find((element) => visibleForAnnouncement(element));
    elements.forEach((element) => {
      const target = Number(element.dataset.target);
      const unlocked = current >= target;
      const previous = priorStates.get(element.dataset.placement);
      const remaining = Math.max(0, target - current);
      const message = unlocked
        ? element.dataset.qualifiedTemplate
        : element.dataset.belowTemplate.replace('[amount]', money(remaining));
      element.hidden = cart.item_count === 0;
      element.dataset.unlocked = String(unlocked);
      element.querySelector('[data-progress-below]').hidden = unlocked;
      element.querySelector('[data-progress-qualified]').hidden = !unlocked;
      element.querySelector('[data-progress-distance]').textContent = money(remaining);
      const bar = element.querySelector('[role="progressbar"]');
      bar.setAttribute('aria-valuenow', String(Math.min(100, Math.floor((current / target) * 100))));
      bar.setAttribute('aria-valuetext', `${money(Math.min(current, target))} of ${money(target)}`);
      element.querySelector('[data-progress-fill]').style.width =
        `${Math.min(100, (current / target) * 100)}%`;
      if (cart.item_count > 0 && previous !== undefined && previous !== unlocked && element === visible) {
        element.querySelector('[data-progress-announcement]').textContent = message;
      }
      priorStates.set(element.dataset.placement, unlocked);
    });
  }

  function onCartUpdate(event) {
    const cart = event?.cartData;
    if (merchandiseTotal(cart) !== null && Number.isFinite(cart?.item_count)) {
      requestId += 1;
      render(cart);
      return;
    }
    const ownRequest = ++requestId;
    document.querySelectorAll(selector).forEach((element) => { element.hidden = true; });
    fetch(`${routes.cart_url}.js`, {
      credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }
    })
      .then((response) => {
        if (!response.ok) throw new Error('Cart progress refresh failed');
        return response.json();
      })
      .then((latest) => { if (ownRequest === requestId) render(latest); })
      .catch(() => {
        // Keep the offer hidden rather than display an amount that may be stale.
      });
  }

  document.querySelectorAll(selector).forEach((element) => {
    priorStates.set(element.dataset.placement, element.dataset.unlocked === 'true');
  });
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-progress-info]');
    if (!button) return;
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;
    const expanded = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', String(expanded));
    panel.hidden = !expanded;
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !event.target.matches('[data-progress-info]')) return;
    const panel = document.getElementById(event.target.getAttribute('aria-controls'));
    if (panel) panel.hidden = true;
    event.target.setAttribute('aria-expanded', 'false');
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
  }
})();
